module.exports = __webpack_public_path__ + "static/3-31f83a22a8bc73297330116f5a4990aa.jpg";